import { CompanyCompanyBriefResourceCompanyBriefOutputJsonldType as CompanyType } from "@/lib/api/generated/model";

/**
 * Dutch labels for a company's type, distinguishing an insurer from a lease
 * company (or dealership) wherever a company brief is shown as a hint —
 * currently the dossiers list's Opdrachtgever filter and the create-dossier
 * form's Opdrachtgever field. Kept exhaustive over the full generated enum
 * so it can't silently go stale if that enum grows.
 */
export const COMPANY_TYPE_LABELS: Record<CompanyType, string> = {
  [CompanyType.insurance]: "Verzekeraar",
  [CompanyType.lease]: "Leasemaatschappij",
  [CompanyType.dealership]: "Autodealer",
  [CompanyType.charging_provider]: "Laadpasaanbieder",
  [CompanyType.sharing_service]: "Deelmobiliteitsaanbieder",
};
